import React, { useContext, useEffect, useState } from "react";
import { Context } from "../Store";
import { useLocation, useParams } from "react-router-dom";
import LoadingStory from "./LoadingStory";
import { getStoriesAzureAPI } from "../utils/getStoriesAzureApi";
import { getVenueName } from "../utils/venues";
import getStoryData from "../utils/storyData";
import styles from "./Form.module.scss";

const MAX_TIKTOK_HANDLE_LENGTH = 24;
const MAX_INSTAGRAM_HANDLE_LENGTH = 30;

const SocialMediaSubmissionPage = () => {
  const [state, setState] = useContext(Context);
  const [instagramProfile, setInstagramProfile] = useState("");
  const [tiktokProfile, setTiktokProfile] = useState("");
  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { guid } = useParams();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const debug = params.get("debug");
  const forceCountry = params.get("country");
  const { StoriesAzureAPI, country } = getStoriesAzureAPI(forceCountry);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (state.guid.length < 1) {
    getStoryData({
      id: guid,
      country,
      StoriesAzureAPI,
      debug,
      getVenueName,
      setState,
      state,
    });

    return (
      <div>
        <LoadingStory />
      </div>
    );
  }

  if (state.country !== "uk") {
    return null;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus("");

    const trimmedInstagram = instagramProfile.trim();
    const trimmedTiktok = tiktokProfile.trim();

    if (!trimmedInstagram && !trimmedTiktok) {
      setStatus("validation");
      return;
    }

    if (trimmedTiktok.length > MAX_TIKTOK_HANDLE_LENGTH || trimmedInstagram.length > MAX_INSTAGRAM_HANDLE_LENGTH) {
      setStatus("length");
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        StoryId: state.guid,
        BookingReference: state.reference,
        InstagramProfile: trimmedInstagram,
        TiktokProfile: trimmedTiktok,
      };

      await StoriesAzureAPI.post("https://flightclubapi.azure-api.net/uk/v2/SubmitSocialMedia", payload);
      setStatus("success");
      setInstagramProfile("");
      setTiktokProfile("");
    } catch (error) {
      setStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.form}>
      <h2>Share your socials</h2>
      <p>
        Want to be tagged? Drop your TikTok and/or Instagram handles below, and we'll be in touch before posting. Please
        note that content may also be featured on our website.
      </p>

      <form className={styles.formFields} onSubmit={handleSubmit}>
        <input
          type="text"
          name="tiktokProfile"
          value={tiktokProfile}
          onChange={(event) => setTiktokProfile(event.target.value)}
          placeholder="TikTok handle"
          maxLength={MAX_TIKTOK_HANDLE_LENGTH}
        />
        <input
          type="text"
          name="instagramProfile"
          value={instagramProfile}
          onChange={(event) => setInstagramProfile(event.target.value)}
          placeholder="Instagram handle"
          maxLength={MAX_INSTAGRAM_HANDLE_LENGTH}
        />
        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
      </form>

      {status === "success" && <p>Thanks! Your details have been submitted.</p>}
      {status === "validation" && <p>Please enter at least one social handle.</p>}
      {status === "length" && <p>TikTok can be max 24 characters and Instagram max 30 characters.</p>}
      {status === "error" && <p>Something went wrong. Please try again.</p>}
    </div>
  );
};

export default SocialMediaSubmissionPage;
